import React, { Fragment, useState, useRef, useEffect } from 'react';
import logo from '../images/lootswap_logo2.png';
import bell from '../images/bell.png';
import profile from '../images/profile.png';
import { Link, withRouter } from 'react-router-dom';
import { signout, isAuthenticated } from '../auth';
import notificationSocket from './notification_socket';
import { getUserInfo } from '../user/apiUser';
import { deleteNotification } from './apiCore';
import Search from './Search';
import SignupModal from '../user/SignupModal';
import SigninModal from '../user/SigninModal';

//tailwind
import { Popover, Transition, Disclosure, Menu } from '@headlessui/react'
import {
    MenuIcon,
    BellIcon,
    XIcon,
    ChatIcon,
    InboxIcon,
    CheckCircleIcon,
    BanIcon,
} from '@heroicons/react/outline'
import { ChevronDownIcon } from '@heroicons/react/solid'


//temp _delet elater

//loggedin menu items
const navigation = [
    { name: 'Trades', href: '/trades', current: false },
    { name: 'Orders', href: '/orders', current: false },
]
const userNavigation = [
    { name: 'Dashboard', href: '/dashboard' },
    { name: 'Report an Issue', href: '#' },
]

const classNames = (...classes) => {
    return classes.filter(Boolean).join(' ')
}

const isActive = (history, path) => {
    if(history.location.pathname === path) {
        return {color: '#ff9900'};
    }
    else {
        return {color: '#ffffff'};
    }
};

//TODO: refactor this please!!!!

const MainMenu = ({ history, children }) => {
    const [notifications, setNotifications] = useState([]);
    const [userInfo, setUserInfo] = useState({});
    const notifRef = useRef();
    notifRef.current = notifications;
    const [newNotif, setNewNotif] = useState(false);
    const [notifIsEmpty, setNotifIsEmpty] = useState(true);

    const [openSignup, setOpenSignup] = useState(false); //signup modal
    const handleOpenSignup = () => setOpenSignup(true);
    const handleCloseSignup = () => setOpenSignup(false);

    const [openSignin, setOpenSignin] = useState(false);
    const handleOpenSignin = () => setOpenSignin(true);
    const handleCloseSignin = () => setOpenSignin(false);

    const AddLootCondition = () => {
        if (userInfo.shipping_address) {
            return (
                <a href='/add-loot'>
                    <button
                        type='button'
                        className='inline-flex items-center px-4 sm:px-2 py-1.5 border border-transparent text-sm font-medium rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
                    >
                        Add Loot
                    </button>
                </a>
            );
        }
        else {
            return (
    <Menu as="div" className="relative inline-block text-left z-50">
      <div>
        <Menu.Button className='inline-flex items-center px-4 sm:px-2 py-1.5 border border-transparent text-sm font-medium rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'>
          Add Loot
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1">
            <Menu.Item>
              {({ active }) => (
                <a
                  href="/dashboard"
                  className={classNames(
                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                    'block px-4 py-2 text-sm'
                  )}
                >
                  You must fill out a shipping address to add loot. Click here to fill
                </a>
              )}
            </Menu.Item>
          </div>
          </Menu.Items>
      </Transition>
    </Menu>
            );
        }
    };

    const checkNotifDuplicate = (content) => { //DEPRICATED (for now)
        //checks if a notification comes from the same trade.
        //if so, then it combines the notification
        var { user: {_id}, token } = isAuthenticated();
        if (content.type == 'message') {
            notifRef.current.forEach(async notif => {
                if (notif.tradeId === content.tradeId) {
                    console.log('isIn');

                    const newNotifications = await notifRef.current.filter(notification =>
                        notification.title !== notif.title
                    );
                    await console.log('newnotific');
                    await console.log(newNotifications);
                    await setNotifications(newNotifications);

                    const newTitle = await content.title.replace('Message','Messages');
                    const combinedNotif = await {type: 'message', tradeId: content.tradeId,title: newTitle,
                        description: content.description, image: content.image,
                        link: content.link, uId: content.uId };

                    await setNotifications(notifications => [...notifications, combinedNotif]);
                    return
                }
            })
        }
    };

    useEffect(() => {
        if (isAuthenticated()){
            var { user: {_id}, token } = isAuthenticated();
            getUserInfo(_id).then(data => {
                setUserInfo(data);
                if (data.notifications) {
                    if (data.notifications.length === 0) {
                        setNewNotif(false);
                        setNotifIsEmpty(true);
                    }
                    else {
                        setNewNotif(true);
                        setNotifIsEmpty(false);

                        setNotifications(data.notifications);

                    }
                }
            });
            const userId = _id;
            notificationSocket.auth = { userId };
            notificationSocket.connect();
            notificationSocket.on('send notification', ({ content, from, to }) => {
                console.log(window.location.href);
                //if (window.location.href === 'http://localhost:8000/trades/')

                setNewNotif(true);
                if (to === _id) {
                    console.log('recieving notification');
                    console.log(content);
                    checkNotifDuplicate(content);

                    //for some reason this if statement has to be here 
                    if (notifications.length === 0) {
                        console.log('isempty');
                        //setNotifications([content]);
                        setNotifications(notifications => [...notifications, content]);
                        setNotifIsEmpty(false);
                    }
                    else {
                        setNotifications(notifications => [...notifications, content]);
                    }
                }
            });

            return function cleanup() {
                notificationSocket.off('connect');
                notificationSocket.off('disconnect');
                notificationSocket.off('send notification');
            };
        }
    },[]);

    const handleNotifClick = (notification) => {
        const content = {title: notification.title, description: notification.description,
            image: notification.image, link: notification.link, uId: notification.uId};
        const { user:{_id}, token } = isAuthenticated(); 

        deleteNotification(content, _id, token).then(async data => {
            const newNotifications = await notifications.filter(notification =>
                notification.uId != content.uId
            );
            if (notifications.length === 1) {
                setNotifIsEmpty(true);
                await console.log(notifications);
            }
            else {
                await setNotifications(newNotifications);
            }
        });;

    };

    const RenderIcon = ({type}) => { //used in notifications
        console.log('type');
        console.log(type);
        if (type === 'accepted') {
            return (
                <CheckCircleIcon className="h-6 w-6 text-green-400" aria-hidden="true" />
            );
        }
        else if (type === 'declined') {
            return ( 
                <BanIcon className='h-6 w-6 text-red-400' aria-hidden='true'/>
            );
        }
        else {
            return (
                <InboxIcon className='h-6 w-6'/>
            );
        }
    };

    if (isAuthenticated()) {
        return (
            <>

                <div className="min-h-full">
                    <Disclosure as="nav" className="bg-white border-b border-gray-200">
                        {({ open }) => (
                            <>
                                <div className="mx-auto px-4 sm:px-6 lg:px-8">
                                    <div className="flex justify-between h-16" >
                                        <div className="flex">
                                            <div className="flex-shrink-0 flex items-center 2-fit">
                                                <a href='/'>
                                                    <img
                                                        className="block lg:hidden sm:h-8 h-8 w-auto"
                                                        src={logo}
                                                        alt="lootswap"
                                                    />
                                                    <img
                                                        className="hidden lg:block sm:h-8 lg:h-8 w-auto"
                                                        src={logo}
                                                        alt="lootswap"
                                                    />
                                                </a>
                                                <div>
                                                    {children}
                                                </div>
                                            </div>

                                        </div>

                                        <div className="hidden sm:my-px sm:flex sm:items-center">
                                            {/* Navigation */}
                                            <div className='space-x-5 sm:flex sm:-my-px'>
                                                {navigation.map((item) => (
                                                    <a
                                                        key={item.name}
                                                        href={item.href}
                                                        className={classNames(
                                                            item.current
                                                                ? 'border-indigo-500 text-gray-900'
                                                                : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                                                            'inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                                                        )}
                                                        aria-current={item.current ? 'page' : undefined}
                                                    >
                                                        {item.name}
                                                    </a>
                                                ))}
                                                <AddLootCondition/>
                                            </div> 


                                            {/*Notifications dropdown */}
                                            <Menu as='div' className='ml-3 relative'>
                                                <div>
                                                    <Menu.Button className='bg-white p-1 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'>
                                                        <BellIcon className="h-6 w-6" aria-hidden="true" onClick={() => setNewNotif(false)}/>
                                                        {newNotif ?
                                                            <span class="absolute bg-red-600 h-2 w-2 rounded-full -top-2 -right-2" />
                                                            :
                                                            <p></p>
                                                        }
                                                    </Menu.Button>
                                                </div>

                                                <Transition
                                                    as={Fragment}
                                                    enter="transition ease-out duration-200"
                                                    enterFrom="transform opacity-0 scale-95"
                                                    enterTo="transform opacity-100 scale-100"
                                                    leave="transition ease-in duration-75"
                                                    leaveFrom="transform opacity-100 scale-100"
                                                    leaveTo="transform opacity-0 scale-95"
                                                >
                                                    <Menu.Items className="origin-top-right absolute right-0 mt-2 w-96 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
                                                        {notifIsEmpty
                                                            ?
                                                                <Menu.Item>
                                                                    {({ active }) => (
                                                                        <p
                                                                            className={classNames(
                                                                                active ? 'bg-gray-100' : '',
                                                                                'block px-4 py-2 text-sm text-gray-700 z-50'
                                                                            )}
                                                                        >
                                                                            No new notifications
                                                                        </p>
                                                                    )}
                                                                </Menu.Item>
                                                                :
                                                                notifications.map((notification, i) => (
                                                                    <Menu.Item key={i}>
                                                                        {({ active }) => (
                                                                            <div>
                                                                                <a
                                                                                    href={notification.link}
                                                                                    onClick={() => handleNotifClick(notification)}
                                                                                    className={classNames(
                                                                                        active ? 'bg-gray-100' : '',
                                                                                        'block px-4 py-2 text-sm text-gray-700 z-50'
                                                                                    )}
                                                                                >
                                                                                    {/* notification widget from tailwind */}
                                                                                    <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
                                                                                        <div className="p-4">
                                                                                            <div className="flex items-start">
                                                                                                <div className="flex-shrink-0">
                                                                                                    <RenderIcon type={notification.type}/>
                                                                                                </div>
                                                                                                <div className="ml-3 w-0 flex-1 pt-0.5">
                                                                                                    <p className="text-sm font-medium text-gray-900">{notification.title}</p>
                                                                                                    <p className="mt-1 text-sm text-gray-500">{notification.description}</p>
                                                                                                </div>
                                                                                                <div className="ml-4 flex-shrink-0 flex">
                                                                                                    {/* X icon went here */}
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </a>



                                                                            </div>
                                                                        )}
                                                                    </Menu.Item>
                                                                ))}
                                                    </Menu.Items>
                                                </Transition>
                                            </Menu>

                                            {/* Profile dropdown */}
                                            <Menu as="div" className="ml-3 relative">
                                                <div>
                                                    <Menu.Button className="max-w-xs bg-white flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                                        <span className="sr-only">Open user menu</span>
                                                        <img className="h-8 w-8 rounded-full" src={userInfo.profile_picture} alt="" />
                                                    </Menu.Button>
                                                </div>
                                                <Transition
                                                    as={Fragment}
                                                    enter="transition ease-out duration-200"
                                                    enterFrom="transform opacity-0 scale-95"
                                                    enterTo="transform opacity-100 scale-100"
                                                    leave="transition ease-in duration-75"
                                                    leaveFrom="transform opacity-100 scale-100"
                                                    leaveTo="transform opacity-0 scale-95"
                                                >
                                                    <Menu.Items className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
                                                        <Menu.Item>
                                                            {({ active }) => (
                                                                <a
                                                                    href='/dashboard/profile'
                                                                    className={classNames(
                                                                        active ? 'bg-gray-100' : '',
                                                                        'block px-4 py-2 text-sm text-gray-700'
                                                                    )}
                                                                >
                                                                    Dashboard
                                                                </a>
                                                            )}
                                                        </Menu.Item>

                                                        <Menu.Item>
                                                            {({ active }) => (
                                                                <a
                                                                    className={classNames(
                                                                        active ? 'bg-gray-100' : '',
                                                                        'block px-4 py-2 text-sm text-gray-700'
                                                                    )}
                                                                    onClick={
                                                                        () => signout(() => {
                                                                            history.push('/');
                                                                        })}
                                                                >
                                                                    Signout
                                                                </a>
                                                            )}
                                                        </Menu.Item>
                                                    </Menu.Items>
                                                </Transition>
                                            </Menu>
                                        </div>
                                        <div className="-mr-2 flex  sm:hidden">
                                            {/* Mobile menu button */}
                                            <Disclosure.Button className="bg-white inline-flex items-center justify-center rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                                <span className="sr-only">Open main menu</span>
                                                {open ? (
                                                    <XIcon className="block h-6 w-6" aria-hidden="true" />
                                                ) : (
                                                    <div>
                                                        <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                                                    </div>
                                                )}
                                            </Disclosure.Button>
                                        </div>
                                    </div>
                                </div>

                                <Disclosure.Panel className="sm:hidden">
                                    <div className="pt-2 pb-3 space-y-1">
                                        {navigation.map((item) => (
                                            <Disclosure.Button
                                                key={item.name}
                                                as="a"
                                                href={item.href}
                                                className={classNames(
                                                    item.current
                                                        ? 'bg-indigo-50 border-indigo-500 text-indigo-700'
                                                        : 'border-transparent text-gray-600 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-800',
                                                    'block pl-3 pr-4 py-2 border-l-4 text-base font-medium'
                                                )}
                                                aria-current={item.current ? 'page' : undefined}
                                            >
                                                {item.name}
                                            </Disclosure.Button>
                                        ))}

                                        <AddLootCondition/>
                                    </div>
                                    <div className="pt-4 pb-3 border-t border-gray-200">
                                        <div className="flex items-center px-4">
                                            <div className="flex-shrink-0">
                                                <img className="h-10 w-10 rounded-full" src={userInfo.profile_picture} alt="" />
                                            </div>
                                            <div className="ml-3">
                                                <div className="text-base font-medium text-gray-800">{userInfo.name}</div>
                                                <div className="text-sm font-medium text-gray-500">{userInfo.email}</div>
                                            </div>
                                            {/* Mobile Notifications Dropdown */}
                                            <span className="sr-only">View notifications</span>
                                            <Menu as='div' className='ml-3 relative'>
                                                <div>
                                                    <Menu.Button className='bg-white p-1 rounded-full'>
                                                        <BellIcon className='h-6 w-6' aria-hidden='true' onClick={() => setNewNotif(false)}/>
                                                        {newNotif ?
                                                            <span className='absolute bg-red-600 h-2 w-2 rounded-full -top-2 -right-2'/>
                                                            :
                                                            <p></p>
                                                        }
                                                    </Menu.Button>
                                                </div>
                                                <Transition
                                                    as={Fragment}
                                                    enter="transition ease-out duration-200"
                                                    enterFrom="transform opacity-0 scale-95"
                                                    enterTo="transform opacity-100 scale-100"
                                                    leave="transition ease-in duration-75"
                                                    leaveFrom="transform opacity-100 scale-100"
                                                    leaveTo="transform opacity-0 scale-95"
                                                >
                                                    <Menu.Items className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                                                        {notifIsEmpty
                                                            ?
                                                                <Menu.Item>
                                                                    {({ active }) => (
                                                                        <p
                                                                            className={classNames(
                                                                                active ? 'bg-gray-100' : '', 
                                                                                'block px-4 py-2 text-sm text-gray-700'
                                                                            )}
                                                                        >
                                                                            No new notifications
                                                                        </p>
                                                                    )}
                                                                </Menu.Item>
                                                                :
                                                                notifications.map((notification, i) => (
                                                                    <Menu.Item key={i}>
                                                                        {({ active }) => (
                                                                            <a
                                                                                href={notification.link}
                                                                                onClick={() => handleNotifClick(notification)}
                                                                                className={classNames(
                                                                                    active ? 'bg-gray-100' : '', 
                                                                                    'block px-4 py-2 text-sm text-gray-700'
                                                                                )}
                                                                            >
                                                                                {notification.title}
                                                                            </a>
                                                                        )}
                                                                    </Menu.Item>
                                                                ))}
                                                    </Menu.Items>
                                                </Transition>
                                            </Menu>
                                        </div>
                                        <div className="mt-3 space-y-1">
                                            <Disclosure.Button
                                                as="a"
                                                href='/dashboard/profile'
                                                className="block px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100"
                                            >
                                                Dashboard
                                            </Disclosure.Button>

                                            <Disclosure.Button
                                                as="a"
                                                className="block px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100"
                                            >
                                                <a
                                                    onClick={
                                                        () => signout(() => {
                                                            history.push('/');
                                                        })}
                                                >
                                                    Signout
                                                </a> 
                                            </Disclosure.Button>
                                        </div>
                                    </div>
                                </Disclosure.Panel>
                            </>
                        )}
                    </Disclosure>
                </div>


            </>
        );
    }
    else {
        return (
            <>


                <Popover className="relative bg-white">
                    <SignupModal open={openSignup} handleClose={handleCloseSignup} handleOpenSignup={handleOpenSignup}/>
                    <SigninModal open={openSignin} handleClose={handleCloseSignin} handleOpenSignup={handleOpenSignup}/>
                    <div className="mx-auto px-4 sm:px-6">
                        <div className="flex justify-between items-center border-b-2 border-gray-100 py-6 md:justify-start md:space-x-10">
                            <div className="flex justify-start lg:w-0 lg:flex-1">
                                <a href="/">
                                    <span className="sr-only">Workflow</span>
                                    <img
                                        className="h-8 w-auto sm:h-10"
                                        src={logo}
                                        alt=""
                                    />
                                </a>
                            </div>

                            <div>
                                {children}
                            </div>

                            <div className="-mr-2 -my-2 md:hidden">
                                <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                                    <span className="sr-only">Open menu</span>
                                    <MenuIcon className="h-6 w-6 pl-2" aria-hidden="true" />
                                </Popover.Button>
                            </div>


                            <div className="hidden md:flex items-center justify-end md:flex-1 lg:w-0">
                                <a onClick={handleOpenSignin} className="whitespace-nowrap text-base font-medium text-gray-500 hover:text-gray-900">
                                    Sign in
                                </a>
                                <a
                                    onClick={handleOpenSignup}
                                    className="ml-8 whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700"
                                >
                                    Sign up
                                </a>
                            </div>
                        </div>
                    </div>

                    <Transition
                        as={Fragment}
                        enter="duration-200 ease-out"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="duration-100 ease-in"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                    >
                        <Popover.Panel focus className="absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden z-50">
                            <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
                                <div className="pt-5 pb-6 px-5">
                                    <div className="flex items-center justify-between">
                                        <div>
                                            <img
                                                className="h-8 w-auto"
                                                src="https://tailwindui.com/img/logos/workflow-mark-indigo-600.svg"
                                                alt="Workflow"
                                            />
                                        </div>
                                        <div className="-mr-2">
                                            <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                                                <span className="sr-only">Close menu</span>
                                                <XIcon className="h-6 w-6" aria-hidden="true" />
                                            </Popover.Button>
                                        </div>
                                    </div>
                                </div>
                                <div className="py-6 px-5 space-y-6">
                                    <div>
                                        <a
                                            onClick={handleOpenSignup}
                                            className="w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700"
                                        >
                                            Sign up
                                        </a>
                                        <p className="mt-6 text-center text-base font-medium text-gray-500">
                                            <a onClick={handleOpenSignin} className="text-indigo-600 hover:text-indigo-500">
                                                Sign in
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Popover.Panel>
                    </Transition>
                </Popover>




            </>
        );
    }
};

export default withRouter(MainMenu);
